export default __webpack_public_path__ + "static/cloudator-responsive-article-hub-76fc7dc43d28c2240fd8202fc988ba48.jpg";